var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-500',
    m: 'size-600',
    l: 'size-800',
    xl: 'size-1140',
    fullscreen: 'fullscreen',
    500: 'size-500',
    600: 'size-600',
    800: 'size-800',
    1140: 'size-1140',
};

export { SIZE_TO_CLASSNAME_MAP };
